import { combineReducers } from 'redux';
import toogleReducer from "./AddOrUpdate/AddOrUpdate";
import BookReducer from "./BookState/BookReducer";

const rootReducer  = combineReducers({
    bookState: BookReducer,
    toogleUpdateReducer: toogleReducer 
}) 

export default rootReducer;